import type { ReactElement } from 'react';

/**
 * A row's Status cell: a read-only "Active" / "Inactive" pill. Same shape as the
 * Status pill on Master Data → Stores → Trades; Active is green and Inactive grey.
 * The change itself is the ActiveToggle icon in the row's Actions column.
 */
export function ActiveStatusPill({
  active,
  onText = 'Active',
  offText = 'Inactive',
}: {
  active: boolean;
  /** The words for each state, e.g. "On" / "Off" for a switch. */
  onText?: string;
  offText?: string;
}): ReactElement {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium ${
        active ? 'border-green-200 bg-green-100 text-green-800' : 'border-gray-200 bg-gray-100 text-gray-600'
      }`}
    >
      {active ? onText : offText}
    </span>
  );
}

export default ActiveStatusPill;
